import { Controller } from "@hotwired/stimulus"

// Under a response stands "Respond": a response is answered under the post,
// as every response is, and this takes the reader to the box with the letter
// addressed - "@alex " at the head of it - so the person written back to is
// told (Notify.mentioned). The address is the envelope, not the words; the
// field is otherwise left as the member had it, and nothing is sent.
export default class extends Controller {
  static values = { handle: String, placeholder: String }

  to(event) {
    event.preventDefault()
    const field = document.querySelector("#letter_composer textarea")
    if (!field) return

    const address = `@${this.handleValue}`
    if (!field.value.includes(address)) {
      field.value = field.value.trim() ? `${address} ${field.value}` : `${address} `
      field.dispatchEvent(new Event("input", { bubbles: true }))
    }
    if (this.hasPlaceholderValue) field.placeholder = this.placeholderValue

    field.scrollIntoView({ behavior: "smooth", block: "center" })
    setTimeout(() => {
      field.focus({ preventScroll: true })
      field.setSelectionRange(field.value.length, field.value.length)
    }, 350)
  }
}
